"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOVES = void 0;
exports.MOVES = Object.freeze({
    RIGHT: { x: 1, y: 0 },
    LEFT: { x: -1, y: 0 },
    UP: { x: 0, y: -1 },
    DOWN: { x: 0, y: 1 },
    STOPPED: { x: 0, y: 0 },
});
